import React from "react";

import * as S from "./OpinModal.style";

function OpinModal({ children, ...props }) {
  return <S.OpinModal {...props}>{children}</S.OpinModal>;
}

export default OpinModal;
